import { useEffect, useState } from 'react'
import { RoleHierarchy } from '../../../shared/src/data/roleHierarchy/roleHierarchy'
import { useStyles } from './Styles'
import { Box, Typography } from '@material-ui/core'
import { SelectRoleHierarchyForScanExecution } from '../steps/scanMetadataSelection/SelectRoleHierarchyForScanExecution'
import SelectScanFromHierarchy from '../steps/scanMetadataSelection/SelectScanFromHierarchy'
import DraggableFileList from './draggableList/dragableFileList'
import { useAnalysisContext } from './contextProvider'
import CheckSelection from './CheckSelection'

export default function SelectionForm(): JSX.Element {
  const [selectedRoleHierarchy, setSelectedRoleHierarchy] =
    useState<RoleHierarchy>()
  const classes = useStyles()
  const { selectedScan, setSelectedScan, files } = useAnalysisContext()

  useEffect(() => {
    setSelectedScan(undefined)
  }, [selectedRoleHierarchy, setSelectedScan])

  return (
    <Box className={classes.fasttrack}>
      <Box className={classes.wrapper}>
        <Box className={classes.selection}>
          <SelectRoleHierarchyForScanExecution
            selectedRoleHierarchy={selectedRoleHierarchy}
            setSelectedRoleHierarchy={setSelectedRoleHierarchy}
          />
          <SelectScanFromHierarchy
            selectedRoleHierarchy={selectedRoleHierarchy}
            selectedScan={selectedScan}
            setSelectedScan={setSelectedScan}
          />
          <Box className={classes.files}>
            {!selectedScan ? (
              <></>
            ) : !selectedScan.uploadId ? (
              <Typography variant='h6'>Scan has no related files</Typography>
            ) : files?.length ? (
              <DraggableFileList />
            ) : (
              <Typography variant='h6'>Scan has no related files</Typography>
            )}
          </Box>
        </Box>
      </Box>
      <Box className={classes.wrapper}>
        <CheckSelection />
      </Box>
    </Box>
  )
}
